import Kernel from './Kernel';

export class Video extends Kernel {
    constructor (target) {
        console.log('Module: Video has been loaded');

        super(target);

        // wait till loaded
        this.init();
    }

    init () {

        // play the video
        this.$el[0].load();
        this.$el[0].play();

        this.$el.on('ended.HomeHero', () => {
            this.$el[0].pause();
            this.$el[0].currentTime = 0;
            this.$el[0].play();
        });
    }
}

export default Video;



// WEBPACK FOOTER //
// ./app/src/js/modules/Video.js